<template>
    <div>
        <div class="mt-4">
            <el-tabs v-model="activeTemplate" type="border-card">

                <el-tab-pane v-if="load.data.sendEmail && template.markup" label="Email" name="email">

                    <div v-if="recipient.email">

                        <div v-if="!_.isEmpty(this.load) && _.isEmpty(this.html) && !this.emailLoaded">
                            <div class="loading-spinner">
                                <div class="lds-roller">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="loading-text">Loading Template</div>
                            </div>
                        </div>

                        <div v-else>

                            <div v-if="!_.isEmpty(template.markup)">

                                <el-form-item class="mt-2" v-if="subject" label="Subject">
                                    <el-input placeholder="Subject" v-model="template.markup.subject"></el-input>
                                </el-form-item>

                                <!-- <email-task v-if="task" v-model="template.task" :userId="userId"></email-task> -->

                                <email-attachments
                                    v-if="attachments"
                                    v-model="template.attachments"
                                    :application-id="applicationId"
                                    :recipientType="recipientType"
                                    :attachmentsFor="attachmentsFor"
                                    :preselectAttachments="preselectAttachments"
                                    :filterRejectedAttachments="filterRejectedAttachments"
                                    :appendAttachments="appendAttachments"
                                ></email-attachments>

                                <email-documents
                                    v-if="showDocuments"
                                    :recipientId="Number(_.get(recipient.id.split('-'), '1', recipient.id))"
                                    :recipientType="recipientType"
                                    :documentsFor="documentsFor"
                                    :preselectDocuments="preselectDocuments"
                                    v-model="template.documents"
                                ></email-documents>

                                <div class="modification-warning"
                                     v-if="applicantRecipientCount > 1 && recipient.group == 'applicant' && template.markup.modified">
                                    If you modify an applicants email template, these changes only apply to that
                                    applicant and may need to be added to the other applicant email templates.
                                </div>

                                <editor
                                    v-model="template.markup.body"
                                    :api-key="apiKey"
                                    :init="{
                                        height: 600,
                                        menubar: false,
                                        plugins: [
                                            'advlist autolink link image lists charmap print preview hr pagebreak spellchecker',
                                            'searchreplace wordcount code fullscreen insertdatetime media nonbreaking',
                                            'table directionality emoticons template paste fullpage',
                                        ],
                                        noneditable_editable_class: 'noneditable',
                                        visual: false,
                                        auto_focus: false,
                                        relative_urls: false,
                                        remove_script_host: false,
                                        toolbar:
                                            'undo redo | formatselect | bold italic backcolor | \
                                    alignleft aligncenter alignright alignjustify | \
                                    bullist numlist outdent indent | removeformat',
                                    }"
                                ></editor>

                            </div>

                            <div v-else>
                                <el-tag type="danger">There isn't a email template attached to this action</el-tag>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <el-tag type="danger">This recipient doesn't have a valid email address</el-tag>
                    </div>
                </el-tab-pane>

                <el-tab-pane v-if="load.data.sendSms" label="SMS" name="sms">

                    <div v-if="recipient.phoneIsMobile">
                        <div v-if="!_.isEmpty(this.load) && _.isEmpty(this.html) && !this.smsLoaded">
                            <div class="loading-spinner">
                                <div class="lds-roller">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="loading-text">Loading Template</div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="mt-2" v-if="_.get(template.smsMarkup, 'body')">
                                <div class="textarea-word-limit">

                                    <div v-if="(smsTextLength > smsTextMaxLength) && isBlankTemplate"
                                         class="text-danger">Error: This text message has exceeded the maximum character
                                        limit.
                                    </div>
                                    <div v-else-if="(smsTextLength > smsTextMaxLength) && !isBlankTemplate"
                                         class="text-warning">Warning: The message is over 320 characters. We recommend
                                        keeping SMS messages to 320 characters or fewer to achieve a better response
                                        rate.
                                    </div>

                                    <el-input v-if="isBlankTemplate"
                                              :autosize="{ minRows: 10 }"
                                              type="textarea"
                                              :class="[{ 'oversize': smsTextLength > smsTextMaxLength }]"
                                              v-model="template.smsMarkup.body"
                                              placeholder=""
                                              show-word-limit
                                    ></el-input>

                                    <el-input v-else-if="!isBlankTemplate"
                                              :autosize="{ minRows: 10 }"
                                              type="textarea"
                                              class="w-100"
                                              :class="[{ 'oversize-warning': smsTextLength > smsTextMaxLength }]"
                                              v-model="template.smsMarkup.body"
                                              placeholder="Type message here"
                                              show-word-limit
                                    ></el-input>

                                    <span v-if="cappedSmsTemplates && isBlankTemplate"
                                          :class="['textarea-word-limit__count', { 'text-danger': smsTextLength > smsTextMaxLength }]">
                                        <span>{{ smsTextLength }}</span>
                                        <span> / {{ smsTextMaxLength }}</span>
                                    </span>
                                    <span v-else-if="!isBlankTemplate"
                                          :class="['textarea-word-limit__count', { 'text-warning': smsTextLength > smsTextMaxLength }]">
                                        <span>{{ smsTextLength }}</span>
                                        <span> / {{ smsTextMaxLength }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-else>
                                <el-tag style="mb-2" type="danger">There isn't a sms template attached to this action.
                                    Select a custom Sms Template from below.
                                </el-tag>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <el-tag type="danger">This recipient doesn't have a valid mobile number</el-tag>
                    </div>

                </el-tab-pane>
            </el-tabs>
        </div>

        <div class="mt-3 template-override">
            <el-form-item class="w-100 custom-sms" label-width="100%" label-position="top-left"
                          label="Custom SMS Template" v-if="load.data.sendSms && selectCustomSmsTemplate">
                <el-select
                    :loading="smsTemplatesLoading"
                    clearable
                    placeholder="Select Custom SMS Template"
                    style="width: 100%"
                    v-model="smsUid"
                >
                    <el-option
                        v-for="smsTemplate in smsTemplates"
                        :key="smsTemplate.uid"
                        :label="smsTemplate.name"
                        :value="smsTemplate.uid"
                    ></el-option>
                </el-select>
            </el-form-item>
        </div>
    </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue"
import EmailAttachments from "@ambition/components/messages/EmailAttachments"
import EmailDocuments from "@ambition/components/messages/EmailDocuments.vue"
import EmailTask from "@ambition/components/messages/EmailTask"

import {mapGetters} from "vuex"

export default {
    name: "EmailTemplate",
    components: {
        Editor,
        EmailAttachments,
        EmailDocuments,
        EmailTask,
    },
    props: {
        applicationId: {
            type: [Number, String],
            required: false
        },
        multi: {
            type: Boolean,
            required: false,
            default: false,
        },
        html: {
            type: String,
            required: false,
            default: "",
        },
        load: {
            type: Object,
            required: false,
            default: function () {
                return {}
            },
        },
        recipient: {
            type: [Object],
            required: false,
        },
        recipientType: {
            type: String,
            required: false,
        },
        subject: {
            type: [Boolean, Object],
            required: false,
            default: true,
        },
        attachments: {
            type: Boolean,
            required: false,
            default: true,
        },
        attachmentsFor: {
            required: false,
            type: [Object],
            default: function () {
                return {}
            },
        },
        preselectAttachments: {
            required: false,
            type: [Array],
            default: function () {
                return []
            },
        },
        filterRejectedAttachments: {
            required: false,
            type: [Boolean],
            default: false,
        },
        appendAttachments: {
            required: false,
            type: [Array],
            default: function () {
                return []
            },
        },
        documents: {
            type: Boolean,
            required: false,
            default: false,
        },
        documentsFor: {
            // required: false,
            type: Object,
            default: function () {
                return {}
            },
        },
        preselectDocuments: {
            // required: false,
            type: Array,
            default: function () {
                return []
            }
        },
        task: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            originalEmailMarkup: "",
            originalSmsMarkup: "",
            template: {
                markup: {},
                smsMarkup: {},
                attachments: [],
                documents: [],
                task: {},
                approvalEmailData: [],
            },
            emailLoaded: false,
            smsLoaded: false,
            activeTemplate: "email",
            smsTemplatesLoading: true,
            smsUid: '',
            selectCustomSmsTemplate: false
        }
    },
    computed: {
        ...mapGetters({
            emailBuilder: "builderEmail/getEmail",
            applicantDocumentsList: "documents/applicantDocumentsList",
            dealerDocumentsList: "documents/dealerDocumentsList",
            sellerDocumentsList: "documents/sellerDocumentsList",
            refinanceDocumentsList: "documents/refinanceDocumentsList",
            personalDocumentsList: "documents/personalDocumentsList",
            activeSmsTemplates: "builderEmail/getActiveSmsTemplates",
            smsTextMaxLength: "builderEmail/smsTextMaxLength",
        }),
        apiKey() {
            return process.env.MIX_TINY_MCE_API
        },
        templatesLoaded() {
            let emailLoaded = true
            if (this.emailBuilder.sendEmail && !this.emailLoaded) {
                emailLoaded = false
            }
            let smsLoaded = true
            if (this.emailBuilder.sendSms && !this.smsLoaded) {
                smsLoaded = false
            }
            let templatesLoaded = [emailLoaded, smsLoaded].every(templateLoaded => templateLoaded === true);
            return templatesLoaded
        },
        cappedSmsTemplates() {
            if (_.has(this.template, 'smsMarkup.name', false) && ['Blank SMS'].includes(this.template.smsMarkup.name)) {
                this.$store.dispatch('builderEmail/setCappedSmsTemplate', true)
                return true
            }
            this.$store.dispatch('builderEmail/setCappedSmsTemplate', false)
            return false
        },
        isBlankTemplate() {
            if (['Blank SMS'].includes(this.template.smsMarkup.name)) {
                return true
            }
            return false
        },
        smsTextLength() {
            let smsText = _.get(this.template, 'smsMarkup.body', '')
            let smsTextCount = _.size(smsText)
            let lineBreakCount = _.size(smsText.match(/\n/g) || [])
            return parseInt(smsTextCount) + parseInt(lineBreakCount)
        },
        smsTemplates() {
            if (!this.activeSmsTemplates) return
            return this.activeSmsTemplates.filter((template) => template.type == "single")
        },
        showDocuments() {
            if (!this.documents) return false
            if (!this.recipient.id) return false
            if (!_.isEmpty(this.documentsFor)) {
                if (!this.recipientType in this.documentsFor) return false
                if (this.recipientType in this.documentsFor && !this.documentsFor[this.recipientType]) return false
            }
            return true
        },
        applicantRecipientCount() {
            return _.size(this.emailBuilder.recipients.filter(recipient => recipient.group == 'applicant'))
        }
    },
    mounted() {
        this.$store.dispatch("builderEmail/setAllSmsTemplates").then((res) => {
            this.smsTemplatesLoading = false
        })
    },
    methods: {
        loadEmailTemplate() {
            this.load.data.applicationId = this.emailBuilder.applicationId ? this.emailBuilder.applicationId : _.get(this.$store.getters, 'appId', this.applicationId)
            this.load.data.loadEmail = true
            this.emailLoaded = false
            let loadData = this.load.data
            axios.post(this.load.url, loadData).then((res) => {
                if (res.data) {
                    this.emailBuilder.canSendEmail = true
                    this.template.markup = _.get(res.data, 'emailTemplate', '')
                    this.originalEmailMarkup = _.get(res.data, 'emailTemplate.body', '')
                    if (_.isObject(this.subject)) {
                        this.template.markup.subject = this.subject.replace
                            ? this.subject.subject
                            : this.template.markup.subject + " " + this.subject.subject
                    }
                } else {
                    this.emailBuilder.canSendEmail = false
                }
                this.emailLoaded = true
            })
        },
        loadSmsTemplate() {
            this.load.data.applicationId = this.emailBuilder.applicationId ? this.emailBuilder.applicationId : _.get(this.$store.getters, 'appId', this.applicationId)
            this.load.data.loadSms = true
            this.smsLoaded = false
            let loadData = this.load.data

            if (this.smsUid) {
                loadData.smsUid = this.smsUid
            }

            axios.post(this.load.url, loadData).then((res) => {
                if (res.data) {
                    this.emailBuilder.canSendSms = true
                    this.template.smsMarkup = _.get(res.data, 'smsTemplate', '')
                    if (_.isEmpty(this.template.smsMarkup)) this.selectCustomSmsTemplate = true
                    this.originalSmsMarkup = _.get(res.data, 'smsTemplate.body', '')
                    if (_.isObject(this.subject)) {
                        this.template.markup.subject = this.subject.replace
                            ? this.subject.subject
                            : this.template.markup.subject + " " + this.subject.subject
                    }
                } else {
                    this.emailBuilder.canSendSms = false
                }
                this.smsLoaded = true
            })
        },
    },
    watch: {
        templatesLoaded: {
            handler(templatesLoaded) {
                this.$store.dispatch('builderEmail/setTemplatesLoaded', templatesLoaded)
            },
            immediate: true
        },
        'template.markup.body': {
            handler(emailMarkup) {
                if (emailMarkup) {
                    this.template.markup.modified = emailMarkup !== this.originalEmailMarkup
                }
            },
            immediate: false,
            deep: true
        },
        'template.smsMarkup.body': {
            handler(smsMarkup) {
                if (smsMarkup) {
                    this.template.smsMarkup.modified = smsMarkup !== this.originalSmsMarkup
                }
            },
            immediate: false,
            deep: true
        },
        'load.data.sendEmail': {
            handler(sendEmail) {
                if (sendEmail) {
                    this.loadEmailTemplate()
                } else {
                    this.activeTemplate = 'sms'
                }
            },
            immediate: true
        },
        'load.data.sendSms': {
            handler(sendSms) {
                if (sendSms) {
                    if (this.recipient.phoneIsMobile) {
                        this.loadSmsTemplate()
                    }
                } else {
                    this.activeTemplate = 'email'
                }
            },
            immediate: true
        },
        'load.data.templateUid': {
            handler(emailTemplate) {
                if (emailTemplate) {
                    this.loadEmailTemplate()
                } else {
                    this.template.markup = {}
                    this.emailBuilder.canSendEmail = false
                }
            }
        },
        'load.data.smsUid': {
            handler(smsTemplate) {
                if (smsTemplate) {
                    this.loadSmsTemplate()
                } else {
                    this.template.smsMarkup = {}
                    this.emailBuilder.canSendSms = false
                }
            }
        },
        smsUid: {
            handler(smsTemplate) {
                if (smsTemplate) {
                    this.loadSmsTemplate()
                } else {
                    this.template.smsMarkup = {}
                    this.emailBuilder.canSendSms = false
                }
            }
        },
        html: {
            handler(html) {
                if (html) {
                    this.template.markup.body = html
                    if (_.isObject(this.subject)) {
                        this.template.markup.subject = this.subject.replace
                            ? this.subject.subject
                            : this.template.markup.subject + " " + this.subject.subject
                    }
                }
            },
            immediate: true,
        },
        template: {
            handler(template, currentTemplate) {
                this.$emit("input", template)
            },
            immediate: true,
            deep: true,
        },
        "template.documents": {
            handler(documents) {
                console.log('template documents ', documents)
                // continue if there are documents and the html has been loaded
                if (documents && this.template.markup.body) {
                    // parse the html template as a dom
                    var dom = new DOMParser().parseFromString(this.template.markup.body, "text/html")

                    let applicantDocumentList = dom.getElementById("applicant-pending-documents")
                    // only continue the applicant document list has been found
                    if (applicantDocumentList) {
                        // clear out the current list and populate with the selected documents
                        applicantDocumentList.innerHTML = ""
                        if (_.size(documents) > 0) {
                            documents.map((document) => {
                                let documentObject = this.applicantDocumentsList.find((documentObject) => documentObject.id === document)
                                if (documentObject) {
                                    let li = `<li class='list-item'>${documentObject.displayName}</li>`
                                    applicantDocumentList.insertAdjacentHTML("beforeend", li)
                                }
                            })
                        } else {
                            let li = `<li class='list-item'>No Documents Required</li>`
                            applicantDocumentList.insertAdjacentHTML("beforeend", li)
                        }
                        // return the body to the editor
                        this.template.markup.body = dom.documentElement.innerHTML
                    }

                    let dealerDocumentList = dom.getElementById("dealer-pending-documents")
                    // only continue the dealer document list has been found
                    if (dealerDocumentList) {
                        // clear out the current list and populate with the selected documents
                        dealerDocumentList.innerHTML = ""

                        if (_.size(documents) > 0) {
                            documents.map((document) => {
                                let documentObject = this.dealerDocumentsList.find((documentObject) => documentObject.id === document)
                                if (documentObject) {
                                    let li = `<li class='list-item'>${documentObject.displayName}</li>`
                                    dealerDocumentList.insertAdjacentHTML("beforeend", li)
                                }
                            })
                        } else {
                            let li = `<li class='list-item'>No Documents Required</li>`
                            dealerDocumentList.insertAdjacentHTML("beforeend", li)
                        }
                        // return the body to the editor
                        this.template.markup.body = dom.documentElement.innerHTML
                    }

                    let sellerDocumentList = dom.getElementById("seller-pending-documents")
                    // only continue the seller document list has been found
                    if (sellerDocumentList) {
                        // clear out the current list and populate with the selected documents
                        sellerDocumentList.innerHTML = ""

                        if (_.size(documents) > 0) {
                            documents.map((document) => {
                                let documentObject = this.sellerDocumentsList.find((documentObject) => documentObject.id === document)
                                if (documentObject) {
                                    let li = `<li class='list-item'>${documentObject.displayName}</li>`
                                    sellerDocumentList.insertAdjacentHTML("beforeend", li)
                                }
                            })
                        } else {
                            let li = `<li class='list-item'>No Documents Required</li>`
                            sellerDocumentList.insertAdjacentHTML("beforeend", li)
                        }
                        // return the body to the editor
                        this.template.markup.body = dom.documentElement.innerHTML
                    }

                    let refinanceDocumentList = dom.getElementById("refinance-pending-documents")
                    // only continue the refinance document list has been found
                    if (refinanceDocumentList) {
                        // clear out the current list and populate with the selected documents
                        refinanceDocumentList.innerHTML = ""

                        if (_.size(documents) > 0) {
                            documents.map((document) => {
                                let documentObject = this.refinanceDocumentsList.find((documentObject) => documentObject.id === document)
                                if (documentObject) {
                                    let li = `<li class='list-item'>${documentObject.displayName}</li>`
                                    refinanceDocumentList.insertAdjacentHTML("beforeend", li)
                                }
                            })
                        } else {
                            let li = `<li class='list-item'>No Documents Required</li>`
                            refinanceDocumentList.insertAdjacentHTML("beforeend", li)
                        }
                        // return the body to the editor
                        this.template.markup.body = dom.documentElement.innerHTML
                    }

                    let personalDocumentList = dom.getElementById("personal-pending-documents")
                    // only continue the personal document list has been found
                    if (personalDocumentList) {
                        // clear out the current list and populate with the selected documents
                        personalDocumentList.innerHTML = ""

                        if (_.size(documents) > 0) {
                            documents.map((document) => {
                                let documentObject = this.personalDocumentsList.find((documentObject) => documentObject.id === document)
                                if (documentObject) {
                                    let li = `<li class='list-item'>${documentObject.displayName}</li>`
                                    personalDocumentList.insertAdjacentHTML("beforeend", li)
                                }
                            })
                        } else {
                            let li = `<li class='list-item'>No Documents Required</li>`
                            personalDocumentList.insertAdjacentHTML("beforeend", li)
                        }
                        // return the body to the editor
                        this.template.markup.body = dom.documentElement.innerHTML
                    }
                }
            },
            immediate: true,
            deep: true,
        },

        "template.approvalEmailData": {
            handler(approvalData) {
                // continue if there are documents and the html has been loaded
                if (!_.isEmpty(approvalData) && this.template.markup.body) {
                    // parse the html template as a dom
                    var dom = new DOMParser().parseFromString(this.template.markup.body, "text/html")
                    let approvalEmailTable = dom.getElementById("approval-email-data")

                    if (_.size(approvalData) <= 0) {
                        approvalEmailTable.style.display = "none"
                    } else {
                        approvalEmailTable.style.display = "table"
                    }

                    // only continue the applicant document list has been found
                    if (approvalEmailTable) {
                        let tbody = approvalEmailTable.getElementsByTagName("tbody")[0]
                        // clear out the current rows
                        tbody.innerHTML = ""
                        approvalData.map((data) => {
                            let tr = `
			                                    <tr>
			                                        <td style='text-align: left'>* ${data.label}:</td>
			                                        <td style='font-weight: bold'>${data.value}</td>
			                                    </tr>
			                                `
                            tbody.insertAdjacentHTML("beforeend", tr)
                        })
                        // return the body to the editor
                        this.template.markup.body = dom.documentElement.innerHTML
                    }
                }
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>

<style lang="scss">

.el-textarea.oversize {
    .el-textarea__inner {
        border-color: #dc3545 !important;
    }
}

.el-textarea.oversize-warning {
    .el-textarea__inner {
        border-color: #f0ad4e !important;
    }
}

.tox-tinymce {
    .tox-statusbar__branding {
        display: none !important;
    }
}

.tox-tinymce-aux {
    z-index: 9999999999 !important;

    .tox-notifications-container {
        display: none !important;
    }
}

.textarea-word-limit {
    position: relative;

    .textarea-word-limit__count {
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 10px;
        font-size: 12px;
        color: #909399;
        pointer-events: all;
    }
}
</style>

<style lang="scss" scope>
.template-override {
    .el-form-item__label {
        text-align: left !important;
        width: 100% !important;
    }

    .el-form-item__content {
        margin-left: 0 !important;
    }
}

.modification-warning {
    background: red;
    padding: 20px;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
}

.loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 200px;
    flex-direction: column;

    .loading-text {
        color: #2493ef;
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;
        margin: 20px 0 0 0;
    }

    .lds-roller {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }

    .lds-roller div {
        animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        transform-origin: 40px 40px;
    }

    .lds-roller div:after {
        content: " ";
        display: block;
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #2493ef;
        margin: -4px 0 0 -4px;
    }

    .lds-roller div:nth-child(1) {
        animation-delay: -0.036s;
    }

    .lds-roller div:nth-child(1):after {
        top: 63px;
        left: 63px;
    }

    .lds-roller div:nth-child(2) {
        animation-delay: -0.072s;
    }

    .lds-roller div:nth-child(2):after {
        top: 68px;
        left: 56px;
    }

    .lds-roller div:nth-child(3) {
        animation-delay: -0.108s;
    }

    .lds-roller div:nth-child(3):after {
        top: 71px;
        left: 48px;
    }

    .lds-roller div:nth-child(4) {
        animation-delay: -0.144s;
    }

    .lds-roller div:nth-child(4):after {
        top: 72px;
        left: 40px;
    }

    .lds-roller div:nth-child(5) {
        animation-delay: -0.18s;
    }

    .lds-roller div:nth-child(5):after {
        top: 71px;
        left: 32px;
    }

    .lds-roller div:nth-child(6) {
        animation-delay: -0.216s;
    }

    .lds-roller div:nth-child(6):after {
        top: 68px;
        left: 24px;
    }

    .lds-roller div:nth-child(7) {
        animation-delay: -0.252s;
    }

    .lds-roller div:nth-child(7):after {
        top: 63px;
        left: 17px;
    }

    .lds-roller div:nth-child(8) {
        animation-delay: -0.288s;
    }

    .lds-roller div:nth-child(8):after {
        top: 56px;
        left: 12px;
    }

    @keyframes lds-roller {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}
</style>
